// Lists configured payment processors. The FPD-052 rate-edit mutation was
// removed per USI-003 / ADR-011 (the FPD-051 fee rollup math it gated is
// deleted in USI-006). Kept as `usePaymentProcessors` because the FPD-022
// threshold-edit UI on `ProcessorRateSettingsPage` still needs the processor
// list — and the file name lives on through callers under the old name.

import { useQuery } from '@tanstack/react-query';
import type { PaymentProcessorListItemDto } from '@signalvote/shared';
import { authService } from '../../services/authService';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';
import { useCampaignStore } from '../../stores';

export function usePaymentProcessors() {
  const { selectedCampaign } = useCampaignStore();
  return useQuery({
    queryKey: queryKeys.finance.paymentProcessors(),
    queryFn: () =>
      apiJson<PaymentProcessorListItemDto[]>('/api/finance/processors', {
        error: 'Failed to fetch payment processors',
      }),
    enabled: authService.isAuthenticated() && !!selectedCampaign,
  });
}
